// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 20V2H2V22H22V20H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.0003 18.2096L21.0003 8.58592L15.3825 14.2033L12.4162 10.7426L6.00026 16.5567L6.00026 18.2096L21.0003 18.2096Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 14.7614L6.00037 12.0593L12.5898 6.06811L15.5566 9.52931L21.0003 4.08643V6.91021L15.4415 12.4682L12.4109 8.93254L6 14.7614Z"}}]};

const ChartAreaMultiFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-area-multi-filled',
    ref,
    icon: element,
  },
));

ChartAreaMultiFilledIcon.displayName = 'ChartAreaMultiFilledIcon';

export default ChartAreaMultiFilledIcon;
